import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

const SISTEMA_STORAGE_KEY = 'sistema_seleccionado';
const EMPRESA_STORAGE_KEY = 'empresa_seleccionada';

@Injectable({
  providedIn: 'root'
})
export class SistemaContextService {
  private sistemaActualSubject = new BehaviorSubject<string | null>(
    this.obtenerSistemaGuardado()
  );

  private empresaActualSubject = new BehaviorSubject<string | null>(
    this.obtenerEmpresaGuardada()
  );

  public sistemaActual$: Observable<string | null> = 
    this.sistemaActualSubject.asObservable();

  public empresaActual$: Observable<string | null> =
    this.empresaActualSubject.asObservable();

  get sistemaActual(): string | null {
    return this.sistemaActualSubject.value;
  }

  get empresaActual(): string | null {
    return this.empresaActualSubject.value;
  }

  establecerSistema(codigo: string, empresaId?: string | null): void {
    localStorage.setItem(SISTEMA_STORAGE_KEY, codigo);
    this.sistemaActualSubject.next(codigo);
    if (empresaId) {
      this.establecerEmpresa(empresaId);
    } else {
      this.limpiarEmpresa();
    }
  }

  establecerEmpresa(empresaId: string | null): void {
    if (empresaId) {
      localStorage.setItem(EMPRESA_STORAGE_KEY, empresaId);
    } else {
      localStorage.removeItem(EMPRESA_STORAGE_KEY);
    }
    this.empresaActualSubject.next(empresaId);
  }

  limpiarSistema(): void {
    localStorage.removeItem(SISTEMA_STORAGE_KEY);
    this.sistemaActualSubject.next(null);
    this.limpiarEmpresa();
  }

  private obtenerSistemaGuardado(): string | null {
    return localStorage.getItem(SISTEMA_STORAGE_KEY);
  }

  private obtenerEmpresaGuardada(): string | null {
    return localStorage.getItem(EMPRESA_STORAGE_KEY);
  }

  private limpiarEmpresa(): void {
    localStorage.removeItem(EMPRESA_STORAGE_KEY);
    this.empresaActualSubject.next(null);
  }

  tieneSistemaSeleccionado(): boolean {
    return !!this.sistemaActual;
  }
}
